import { IPartnerConfiguration } from "@gamedev-web/gamedev-sdk-core";

import { PartnerId } from "../constants";
import { OnboardingPartnerState } from "../redux/reducers/rootReducer";
import { routes } from "./routes";

export const partnerConfig: IPartnerConfiguration<typeof PartnerId, OnboardingPartnerState> = {
  partnerId: PartnerId,
  routes,
  lazyConfig: () => import(/* webpackChunkName: "onboarding-partner" */ "./lazyPartnerConfig"),
};
